import AboutUs from "@/components/aboutUs";
import Footer from "@/components/footer";
import NavBar from "@/components/ui/navbar";
import PageLayout from "./PageLayout";

const AboutUsPage = () => {
    return(
        <>
       <AboutUs />
        </>
    )
}
export default AboutUsPage;